import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { MapStateToPropsFactory } from "react-redux";
import { BetslipStep } from "@ppb/tbd-store/state/betslip/Betslip.types";
import { RefObject } from "react";

export type ContainerProps = {
  drawerRef?: RefObject<HTMLDivElement | null>;
};

export type StateProps = {
  step: BetslipStep;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps | false, ContainerProps, BetslipApplicationState> =
  () => (state) => {
    const step = state.betslipModule?.step;
    if (!step) {
      return false;
    }

    return { step };
  };
